import { render } from "./Receipt.vue?vue&type=template&id=1772a5d9&scoped=true"
import script from "./Receipt.vue?vue&type=script&lang=js"
export * from "./Receipt.vue?vue&type=script&lang=js"

import "./Receipt.vue?vue&type=style&index=0&id=1772a5d9&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1772a5d9"]])

export default __exports__